import { render, staticRenderFns } from "./shareholderdividends.vue?vue&type=template&id=b0534946&scoped=true"
import script from "./shareholderdividends.vue?vue&type=script&lang=js"
export * from "./shareholderdividends.vue?vue&type=script&lang=js"
import style0 from "./shareholderdividends.vue?vue&type=style&index=0&id=b0534946&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0534946",
  null
  
)

export default component.exports